import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


@Injectable()
export class TopbarService {

  private searchTextSubject = new Subject<string>();
  private topbarTitleSubject = new Subject<{ title: string, placeholder: string }>();

  get searchTextSubscribe(): Observable<string> { return this.searchTextSubject.asObservable(); }
  get topbarTitleSubscribe(): Observable<{ title: string, placeholder: string }> { return this.topbarTitleSubject.asObservable(); }

  public nextSearchText(text: string) {
    this.searchTextSubject.next(text);
  }

  public nextTopbarTitleData(title: string, placeholder?: string) {
    this.topbarTitleSubject.next({ title, placeholder: placeholder || '' });
  }
}
